export const headerArrayPlantWise = [
  "Logistics Sheet Recommended",
  "Plant wise cost (Rs. Cr.)",
  "Returnable (Nos)",
  "Expendable (Nos)"
];

export const headerInfoPlantWise = {
  title: "TML Plant Names",
  data: headerArrayPlantWise,
  width: "290px"
};

export const headerArrayUserWise = [
  "No of Recommendations",
  "No of Returnable Strategy Recomm.",
  "No of Expendable Strategy Recomm.",
  "TML Recommended Cost (Rs. Cr.)",
  "Supplier Proposed Cost (Rs. Cr.)",
  "Total No of FH Cases",
  "Total No of FLS Cases",
  "Total No of FCA Cases",
  "Total No of EXWORKS Cases",
  "FH Tonnage/Month",
  "FLS Tonnage/Month",
  "FCA Tonnage/Month",
  "EXWORKS Tonnage/Month",
  "Cost Avoidance (Rs. Cr.)"
];

export const headerInfoUserWise = {
  title: "Names",
  data: headerArrayUserWise,
  width: "290px"
};

export const UserWiseTable = [
  "No of Recommendations",
  "No of Expendable Strategy Recommendations",
  "No of Returnable Strategy Recommendations",
  "No of Recommendations Included In Part Cost",
  "% of Inclusive In Part Cost Cases",
  "Supplier Proposed Cost (Rs. Cr.)",
  "TML Recommended Cost (Rs. Cr.)",
  "Total No of FH Cases",
  "FH Tonnage/Month",
  "Total No of FLS Cases",
  "FLS Tonnage/Month",
  "Total No of FCA Cases",
  "FCA Tonnage/Month",
  "Total No of EXWORKS Cases",
  "EXWORKS Tonnage/Month"
];

export const UserWiseTableHeader = {
  title: "Months",
  data: UserWiseTable,
  width: "290px"
};

export const downloadMisReportSummury = ["Monthly", "Yearly"];

export const customStyle = {
	control: (provided, state) => ({
		...provided,
		backgroundColor: 'transparent',
		border: '1px #757575 solid',
		borderRadius: '6px',
		color: '#757575',
		fontWeight: '600',
		fontSize: 'medium',
		width: '9.5rem',
		height: '1rem',
		cursor: 'pointer',
    flexWrap: 'nowrap'
	}),
	indicatorSeparator: (state) => ({
		...state,
		display: 'none',
	}),
	singleValue: (provided) => ({
		...provided,
		color: 'none',
	}),
	input: (provided) => ({
		...provided,
		display: 'flex',
		height: '100%',
		padding: '0',
		margin: '0',
    cursor: 'pointer',
	}),
};
